import { useNavigate } from "react-router-dom";
import { ArrowRight, Clock, TrendingUp, Dumbbell, Moon } from "lucide-react";

const POSTS = [
  {
    slug: "wat-is-vasten",
    tag: "Voeding",
    tagColor: "text-orange-400 bg-orange-500/10 border-orange-500/25",
    title: "Wat is vasten — en werkt het echt?",
    excerpt: "Intermittent fasting uitgelegd: de wetenschap achter 16:8, 18:6 en OMAD, de voordelen voor vetverlies, en hoe je er mee begint.",
    readTime: "6 min",
    icon: <TrendingUp size={20} className="text-orange-400" />,
  },
  {
    slug: "hoe-vaak-trainen",
    tag: "Training",
    tagColor: "text-blue-400 bg-blue-500/10 border-blue-500/25",
    title: "Hoe vaak moet je trainen — en waarom?",
    excerpt: "Beginner of gevorderd: de optimale trainingsfrequentie voor spiergroei en kracht, onderbouwd met wetenschap en praktijk.",
    readTime: "7 min",
    icon: <Dumbbell size={20} className="text-blue-400" />,
  },
  {
    slug: "herstel-en-spiergroei",
    tag: "Herstel",
    tagColor: "text-emerald-400 bg-emerald-500/10 border-emerald-500/25",
    title: "Herstel: de meest onderschatte factor in je training",
    excerpt: "Slaap, voeding, actief herstel en stressmanagement — de vier pijlers die bepalen hoeveel resultaat je terugkrijgt van elke sessie.",
    readTime: "8 min",
    icon: <Moon size={20} className="text-emerald-400" />,
  },
];

export default function BlogSection() {
  const navigate = useNavigate();

  return (
    <section className="py-24 px-4" style={{ background: "#080808" }}>
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-12 flex-wrap gap-4">
          <div>
            <p className="text-[#C9A84C] text-xs font-bold uppercase tracking-widest mb-3">Kennisbank</p>
            <h2 className="text-white font-bold text-4xl">FitSmith Blog</h2>
            <p className="text-zinc-500 mt-3 max-w-md">
              Praktische kennis over training, voeding en herstel — geschreven door een gecertificeerd personal trainer.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {POSTS.map((post, i) => (
            <article key={post.slug}
              onClick={() => navigate(`/blog/${post.slug}`)}
              className="group bg-[#0f0f0f] border border-white/8 rounded-2xl p-6 hover:border-[#C9A84C]/30 transition-all duration-300 cursor-pointer"
              style={{ animationDelay: `${i * 0.1}s` }}
              data-testid={`blog-card-${post.slug}`}>
              <div className="w-12 h-12 rounded-xl bg-[#111] border border-white/8 flex items-center justify-center mb-4 group-hover:border-[#C9A84C]/30 transition-colors">
                {post.icon}
              </div>
              <div className="flex items-center gap-2 mb-3">
                <span className={`text-xs font-bold px-2 py-0.5 rounded-full border ${post.tagColor}`}>
                  {post.tag}
                </span>
                <span className="text-zinc-600 text-xs flex items-center gap-1">
                  <Clock size={10} /> {post.readTime}
                </span>
              </div>
              <h3 className="text-white font-bold text-base mb-2 group-hover:text-[#C9A84C] transition-colors leading-snug">
                {post.title}
              </h3>
              <p className="text-zinc-500 text-sm leading-relaxed">{post.excerpt}</p>
              <div className="flex items-center gap-1 mt-4 text-[#C9A84C] text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                Lees artikel <ArrowRight size={12} />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
